import { render } from "./CampaignsHp.vue?vue&type=template&id=def6b55c"
import script from "./CampaignsHp.vue?vue&type=script&lang=js"
export * from "./CampaignsHp.vue?vue&type=script&lang=js"

import "./CampaignsHp.vue?vue&type=style&index=0&id=def6b55c&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__